__webpack_require__.p = "/my_portfolio_project/";